export const SET_MESSAGE = 'SET_MESSAGE';

export const FETCH_MESSAGE = 'FETCH_MESSAGE';
